import React from 'react';
import PhasesForm from './PhasesForm';

export const PhasesWidget = () => {
    return <PhasesForm />;
};

export default PhasesWidget;
